// src/components/common/Loading.jsx
import React from 'react';

const sizes = {
  sm: 'w-6 h-6',
  md: 'w-10 h-10',
  lg: 'w-14 h-14'
};

const Loading = ({ size = 'md', color = 'border-primary-600', className = '' }) => {
  const sizeClass = sizes[size] || sizes.md;

  return (
    <div className={`flex justify-center items-center py-12 ${className}`}>
      <div className={`animate-spin rounded-full ${sizeClass} border-b-2 ${color}`}></div>
    </div>
  );
};

export default Loading;
